import { render } from "./Card.vue?vue&type=template&id=087a0ee9&scoped=true&ts=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=087a0ee9&lang=scss&scoped=true"

import exportComponent from "../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-087a0ee9"]])

export default __exports__